"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_RATE = exports.IMAGE_ITEM_WIDTH = exports.CLOSE_ICON = exports.CHEVRON_RIGHT_ICON = exports.CHEVRON_LEFT_ICON = exports.ARROW_RIGHT = exports.ARROW_LEFT = exports.ALL_CATEGORY_ID = void 0;
var ALL_CATEGORY_ID = 0;
exports.ALL_CATEGORY_ID = ALL_CATEGORY_ID;
var IMAGE_ITEM_WIDTH = 136;
exports.IMAGE_ITEM_WIDTH = IMAGE_ITEM_WIDTH;
var MAX_RATE = 5;
exports.MAX_RATE = MAX_RATE;
var ARROW_LEFT = 'ArrowLeft';
exports.ARROW_LEFT = ARROW_LEFT;
var ARROW_RIGHT = 'ArrowRight';
exports.ARROW_RIGHT = ARROW_RIGHT;
var CHEVRON_LEFT_ICON = 'ChevronLeftIcon';
exports.CHEVRON_LEFT_ICON = CHEVRON_LEFT_ICON;
var CHEVRON_RIGHT_ICON = 'ChevronRightIcon';
exports.CHEVRON_RIGHT_ICON = CHEVRON_RIGHT_ICON;
var CLOSE_ICON = 'CloseIcon';
exports.CLOSE_ICON = CLOSE_ICON;